import { render, staticRenderFns } from "./PlantPrintTemplatesData.vue?vue&type=template&id=a0a8f27a&"
import script from "./PlantPrintTemplatesData.vue?vue&type=script&lang=ts&"
export * from "./PlantPrintTemplatesData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports